import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  padding: 0 12px;

  @media (min-width: 620px) {
    padding: 0;
  }
`;

export const ChartWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ChartContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  padding: 16px;
  border-radius: 8px;
  flex: 1;
`;

export const ChartTitle = styled.p`
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 16px;
  text-align: center;
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 12px;

  h1 {
    font-size: 1.6rem;
    color: #f4f4f4;
  }
`;

export const ActionsContainer = styled.div`
  margin-left: auto;
  display: flex;
  gap: 16px;
`;

export const GridContainer = styled.div`
  margin-top: 16px;
  width: 100%;
  height: calc(100vh - 565px);
`;

export const Button = styled.button`
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: 0;
  font-size: 1.2rem;
  background: rgba(0, 0, 0, 0.3);
  color: #f4f4f4;
  cursor: pointer;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);

  h2 {
    color: #333;
    font-size: 1.4rem;
    margin-bottom: 20px;
    text-align: center;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  label {
    color: #444;
    display: flex;
    flex-direction: column;
    gap: 8px;

    input[type='date'] {
      background: rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      height: 44px;
      padding: 0 15px;
      color: #333;
      font-size: 14px;
      
      &::-webkit-calendar-picker-indicator {
        cursor: pointer;
      }
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const ModalButton = styled.button`
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: 0;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.2s;

  background: ${(props) => (props.primary ? '#7159c1' : 'transparent')};
  color: ${(props) => (props.primary ? '#fff' : '#666')};

  &:hover {
    opacity: 0.8;
  }
`;
